import {
  set,
  lensPath,
  indexBy,
  prop,
  dissoc
} from 'ramda'
import { USERS } from '../constants/ActionTypes'

import toLoadable from '../helpers/to-loadable'

const initialState = {
  isLoading: false,
  isCreating: false,
  data: {}
}

export default function users(state = initialState, action) {
  switch (action.type) {

    case USERS.FETCH.REQUEST:
      return { ...state, isLoading: true }
    case USERS.FETCH.RECEIVE:
      return { ...state, isLoading: false, data: toLoadable(indexBy(prop('id'), action.payload)) }
    case USERS.FETCH.ERROR:
      return { ...state, isLoading: false }

    case USERS.UPDATE.REQUEST:
      return set(lensPath(['data', action.payload.id, 'isLoading']), true, state)
    case USERS.UPDATE.RECEIVE:
      return set(lensPath(['data', action.meta.id]), { isLoading: false, data: action.payload }, state)
    case USERS.UPDATE.ERROR:
      return set(lensPath(['data', action.meta.id, 'isLoading']), false, state)

    case USERS.DELETE.REQUEST:
      return set(lensPath(['data', action.payload.id, 'isLoading']), true, state)
    case USERS.DELETE.RECEIVE:
      return { ...state, data: dissoc(action.meta.id, state.data) }
    case USERS.DELETE.ERROR:
      return set(lensPath(['data', action.meta.id, 'isLoading']), true, state)

    default:
      return state
  }
}
